var map = {
	"./message-cn.json": "pELr",
	"./message-en.json": "pOMu",
	"./message-jp.json": "ZqSJ",
	"./message-ko.json": "rF21",
	"./message-vi.json": "bBkl"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "UqZV";


//////////////////
// WEBPACK FOOTER
// ./src/_fdp/core/i18n/bundle ^\.\/message\-.*\.json$
// module id = UqZV
// module chunks = 1